import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import styles from './Surgery.module.scss';
import implantImg from '../../../shared/assets/photo/implant/implantCard.png';
import implantImg_2x from '../../../shared/assets/photo/implant/implantCard_2x.png';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const Surgery = () => {

    useGSAP(() => {     
        gsap.to(".implantImg", 
            {  
            duration: 2,          
            border: '2px solid #30AFB8',
            scrollTrigger: {
                trigger: ".implantImg"
        }});
    }, [])

    return ( 
        <div>
            <Stack
                direction = 'column'
                gap = '16'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.container}>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>
                        Современная хирургическая стоматология решает широкий круг задач, и 
                        ориентирована преимущественно на сохранение даже безнадежных зубов. 
                        В нашей клинике проводятся различные зубосохраняющие операции.

                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                        
                        Однако бывают случаи когда лечение неэффективно и удаление зуба неизбежно.                        
                </Text>
                <Text
                    type='h3' 
                    size ='m'
                    className={styles.title}>                       
                        В настоящее время самый эффективный метод восстановления  
                        зубов - это дентальная имплантация. Имплантаты замещают собой корни 
                        утраченных зубов, позволяя впоследствии провести восстановление зубного ряда.
                </Text>
            </Stack>
            <Stack 
                justifyContent='justifyStart'
                alignItems ='alignCenter'
                className={styles.dark}>
                    <Stack
                        direction = 'column'
                        gap = '16'
                        justifyContent='justifyStart'
                        alignItems ='alignCenter'
                        className={styles.content}>   
                            <Text                             
                                size ='xl'
                                className={styles.textTitle}>
                                    Имплантаты                            
                            </Text>                       
                            <Text                             
                                size ='m'
                                className={styles.text}>                       
                                Имплантат - это искусственный корень, который внедряется 
                                в костную часть челюсти и на него в последующем 
                                устанавливается коронка.                           
                            </Text>

                            <Text                             
                                size ='m'
                                className={styles.text}>               
                                Имплантаты изготавливаются из титана. Этот металл прочный и легкий, 
                                не опасный для организма, абсолютно инертен, то есть 
                                не ржавеет, не гниет и крайне редко вызывает аллергии.
                            </Text>
                            <Text                             
                                size ='m'
                                className={styles.text}>
                                    Основным преимуществом дентальной имплантации является то, 
                                    что при отсутствии большого количества зубов,  
                                    можно избежать установки съемного протеза. 
                            </Text>

                    </Stack>
                    <div className={styles.imgContainer}>
                        <img className={` implantImg ${styles.picture}`} src={implantImg}
                                srcSet={`${implantImg_2x} 2x`} alt="гигиена" />
                    </div>
            </Stack>
        </div>
     );
}
 
export default Surgery;